import type {
  MarketingRouterTreatment,
  MarketingRouterTreatmentType,
} from '@luxuryescapes/contract-svc-promo/marketing-router/admin';

export type MarketingRouterTreatmentDraft = {
  type: MarketingRouterTreatmentType;
  promoCodeName?: string;
  voucherName?: string;
  destinationUrl?: string;
};

function getTreatmentFieldValue(
  treatment: MarketingRouterTreatmentDraft,
  field: 'promoCodeName' | 'voucherName' | 'destinationUrl',
) {
  return field in treatment ? (treatment[field] ?? '') : '';
}

export function normalizeTreatmentForType(
  treatment: MarketingRouterTreatmentDraft,
  type: MarketingRouterTreatmentType,
): MarketingRouterTreatmentDraft {
  switch (type) {
    case 'promo-popup':
      return {
        type,
        promoCodeName: getTreatmentFieldValue(treatment, 'promoCodeName'),
      };
    case 'gha-redirect':
      return {
        type,
        destinationUrl: getTreatmentFieldValue(treatment, 'destinationUrl'),
      };
    case 'voucher-popup-if-owned':
    case 'voucher-popup-allow-claim':
      return {
        type,
        voucherName: getTreatmentFieldValue(treatment, 'voucherName'),
      };
  }
}

export function getPersistedTreatmentValue(treatment: MarketingRouterTreatmentDraft): MarketingRouterTreatment {
  switch (treatment.type) {
    case 'promo-popup':
      return {
        type: treatment.type,
        promoCodeName: getTreatmentFieldValue(treatment, 'promoCodeName'),
      };
    case 'gha-redirect':
      return {
        type: treatment.type,
        destinationUrl: getTreatmentFieldValue(treatment, 'destinationUrl'),
      };
    case 'voucher-popup-if-owned':
    case 'voucher-popup-allow-claim':
      return {
        type: treatment.type,
        voucherName: getTreatmentFieldValue(treatment, 'voucherName'),
      };
  }
}

export function getTreatmentFieldValueForDraft(
  treatment: MarketingRouterTreatmentDraft,
  field: 'promoCodeName' | 'voucherName' | 'destinationUrl',
): string {
  return getTreatmentFieldValue(treatment, field);
}
